import type {
  BudgetDistribution,
  DistributionInputMode,
  DistributionOrigin,
  DistributionPeriodType,
  PortionStatus,
} from '@/domain/budgetDistribution/BudgetDistribution'

interface RawPortion {
  period_start: string
  period_type: DistributionPeriodType
  amount: string
  percentage: string
  status: PortionStatus
  budget_id: number | null
  period_label: string
}

export interface RawBudgetDistribution {
  total: string
  input_mode: DistributionInputMode
  origin: DistributionOrigin | null
  follows_source: boolean
  review_required: boolean
  rescaled_from_total?: string | null
  editable_from: string
  portions: RawPortion[]
}

export function mapBudgetDistribution(raw: RawBudgetDistribution): BudgetDistribution {
  return {
    total: Number(raw.total),
    inputMode: raw.input_mode,
    origin: raw.origin,
    followsSource: raw.follows_source,
    reviewRequired: raw.review_required,
    rescaledFromTotal: raw.rescaled_from_total ? Number(raw.rescaled_from_total) : null,
    editableFrom: raw.editable_from,
    portions: raw.portions.map((portion) => ({
      periodStart: portion.period_start,
      periodType: portion.period_type,
      amount: Number(portion.amount),
      percentage: Number(portion.percentage),
      status: portion.status,
      budgetId: portion.budget_id,
      periodLabel: portion.period_label,
    })),
  }
}
